import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CloudIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.5 13.3653H4L4.00005 13.3299C2.30388 13.0873 1 11.6286 1 9.86526C1 8.06011 2.36658 6.57414 4.12162 6.38548C4.55776 4.65007 6.12884 3.36526 8 3.36526C10.1422 3.36526 11.8911 5.04924 11.9951 7.16563L12 7.36526C13.6569 7.36526 15 8.70841 15 10.3653C15 12.0222 13.6569 13.3653 12 13.3653H4.5Z"
		/>
	</svg>
))
